import { combineReducers } from '@reduxjs/toolkit';
import stylistSlice from './stylistSlice';
import bookingReducer from './bookingSlice';
import salonReducer from './salonSlice';
import serviceSlice from './serviceSlice';

const rootReducer = combineReducers({
  stylist: stylistSlice.reducer,
  booking: bookingReducer,
  salon: salonReducer,
  service: serviceSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
